import { CircularProgress, Stack } from '@mui/material';
import { t } from 'i18next';

export const SessionLoadingSpinner = () => {
  return (
    <Stack direction="column" sx={{ flex: '1', gap: '2rem', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress
            color="primary"
            {...{ 'data-testid': 'sessionLoadingSpinner' }}
        />
        {t('page.loading')}
    </Stack>
  );
};